import { use, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router";
import { auth } from "../firebase";
import styled from "styled-components";

export default function LoginAdmin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('admin/panel')
        } catch (err) {
            setError('Correo o contraseña incorrectos')
        }
    };

    return (
        <Contenedor>
            <FormularioLogin>

                <Titulo>Acceso Inventario</Titulo>
                <Input 
                    type="email"
                    placeholder="Correo electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Input 
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Boton type="submit">Ingresar</Boton>
                {error && <MensajeError>{error}</MensajeError>}
            </FormularioLogin>
        </Contenedor>
    );

};

const Contenedor = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f6fa;
  padding: 20px;
`;

const FormularioLogin = styled.form`
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 400px;
`;

const Titulo = styled.h2`
  text-align: center;
  color: #010755;
`;

const Input = styled.input`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;

  &:focus {
    border-color: #010755;
  }
`;

const Boton = styled.button`
  background-color: #010755;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background-color: #020b9c;
  }
`;

const MensajeError = styled.p`
  color: red;
  text-align: center;
  font-size: 0.9rem;
`;